import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./views/LandingPage/LandingPage";
import ServiceDetailsPage from "./views/ServiceDetailsPage/ServiceDetailsPage";
import AboutPage from "./views/AboutPage/AboutPage";
import ContactPage from "./views/ContactPage/ContactPage";
import OrderNowPage from "./views/OrderNowPage/OrderNowPage";
import ProductDetailsPage from "./views/ProductDetailsPage/ProductDetailsPage";
import ProductPortfolioPage from "./views/ProductPortfolioPage/ProductPortfolioPage";
import PrivateOutlet from "./utils/PrivateOutlet";
import DashboardPage from "./views/DashboardPage/DashboardPage";
import LoginPage from "./views/LoginPage/LoginPage";
import AddProductPage from "./views/AddProductPage/AddProductPage";
import { ToastContainer } from "react-toastify";
import setAuthToken from "./utils/setAuthToken";
import { useEffect } from "react";
import { getRefreshToken } from "./actions/Dashboard.action";
import { connect } from "react-redux";
import AdminContactPage from "./views/AdminContactPage/AdminContactPage";

function App({ getRefreshToken, auth }) {
  if (localStorage.getItem("technowren")) {
    setAuthToken(localStorage.getItem("technowren"));
  }
  useEffect(() => {
    if (!auth) {
      getRefreshToken();
    }
  }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/details/:id" element={<ProductDetailsPage />} />
        <Route path="/services/:slug" element={<ServiceDetailsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/shop" element={<ProductPortfolioPage />} />
        <Route path="/order" element={<OrderNowPage />} />
        <Route path="/order/:type" element={<OrderNowPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<PrivateOutlet />}>
          <>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="contact-submissions" element={<AdminContactPage />} />
            <Route path="dashboard/product/add" element={<AddProductPage />} />
            <Route
              path="dashboard/product/:id"
              element={<AddProductPage edit={true} />}
            />
          </>
        </Route>
      </Routes>
      <ToastContainer />
    </>
  );
}
const mapStateToProps = (state) => ({
  auth: state.auth.isAuthenticated,
});
export default connect(mapStateToProps, { getRefreshToken })(App);
